import React from "react";
import { useHistory } from "react-router-dom";
import { Wrapper, Breadcrumbs, BackButton } from "@networkraildigitalfactory/components";
import PageTitle from "../PageTitle/PageTitle";
import CloseObjectiveList from "../CloseObjectivesList/CloseObjectiveList";
import styles from "./ViewCloseObjectives.module.css";

const ViewClosedObjectives = (props) => {
  const { prevPath } = props;
  const history = useHistory();
  const paragraph = [
    "Objectives will close automatically as part of the EOY review process. \n\nThis feature for should only be used if you have not had an EOY review and need to close your objectives from a previous performance year.",
  ];

  const goBack = () => {
    history.goBack();
  };

  return (
    <>
      <div className={styles.breadcrumbs_wrapper}>
        <Breadcrumbs
          items={[
            {
              text: prevPath === "/my-objectives/objectives" ? "My objectives" : "My performance",
              onClick: () => {
                goBack();
              },
            },
            {
              text: "Close objectives",
            },
          ]}
        />
      </div>
      <Wrapper maxWidth={1375} align="center">
        <div className={styles.back}>
          <BackButton
            text={
              prevPath === "/my-objectives/objectives"
                ? "back to my objectives"
                : "back to my performance"
            }
            onClick={() => {
              goBack();
            }}
            style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
          />
        </div>
        <PageTitle titleHeader="Close objectives" titleParagraph={paragraph} hideButton />
        <CloseObjectiveList />
      </Wrapper>
    </>
  );
};

export default ViewClosedObjectives;
